import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HttpStateService {
  private activeRequests = 0;
  private isRequestingSubject = new BehaviorSubject<boolean>(false);
  public isRequesting$ = this.isRequestingSubject.asObservable();

  constructor() {}

  public startRequest() {
    this.activeRequests++;
    if (this.activeRequests > 0) {
      this.isRequestingSubject.next(true);
    }
  }

  public endRequest() {
    this.activeRequests = Math.max(0, this.activeRequests - 1);
    if (this.activeRequests === 0) {
      this.isRequestingSubject.next(false);
    }
  }

  public forceReset() {
    this.activeRequests = 0;
    this.isRequestingSubject.next(false);
  }
}
